import React, { useState } from 'react';
import { Container, Row, Col, Card, Image } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import TeamContent from '../../data/reshto.json';
import SectionTitle from '../ui/SectionTitle';
import { motion } from 'framer-motion';

export default function Team() {
    const [TeamList] = useState(TeamContent);
    return (
        <>
            <motion.section className='section' id='chefs' initial={{opacity: 0}} whileInView={{opacity: 1}} transition={{duration: 0.5}}>
                <Container>
                    <Row className='justify-content-center'>
                        <Col md={6} className='section-title text-center mb-5'>
                            <SectionTitle title="Meet Our Chefs"/>
                        </Col>
                    </Row>
                    <Row>
                        {TeamList.TeamData.map((data, i) =>
                            <Col sm={6} xl={3} key={i}>
                                <Image src={require(`../../images/team/${data.chefImg}`)} alt="" className='img-fluid w-100 rounded-3 png-img-shadow-sm' />

                                <Card className='text-center card-hover rounded-3 mx-3 mt-n4'>
                                    <Card.Body>
                                        <motion.h5 className='fs-24 mb-1' initial={{opacity: 0 ,y: 20}} whileInView={{opacity: 1, y: 0}} transition={{duration: 0.5}} custom={i}>{data.chefName}</motion.h5>
                                        <motion.p className='text-muted fs-16 text-uppercase mb-4' initial={{opacity: 0 ,y: 20}} whileInView={{opacity: 1, y: 0}} transition={{duration: 0.5}} custom={i}>{data.chefInfo}</motion.p>
                                        <motion.div className='social-icons justify-content-center' initial={{opacity: 0 ,y: 20}} whileInView={{opacity: 1, y: 0}} transition={{duration: 0.5}} custom={i}>
                                            <Link to={{ pathname: data.facebookLinks }} target="_blank" className='social-icon'>
                                                <i className="ri-facebook-circle-fill"></i>
                                            </Link>
                                            <Link to={{ pathname: data.twitterLinks }} target="_blank" className='social-icon'>
                                                <i className="ri-twitter-fill"></i>
                                            </Link>
                                            <Link to={{ pathname: data.linkedinLinks }} target="_blank" className='social-icon'>
                                                <i className="ri-linkedin-box-fill"></i>
                                            </Link>
                                            <Link to={{ pathname: data.skypeLinks }} target="_blank" className='social-icon'>
                                                <i className="ri-skype-fill"></i>
                                            </Link>
                                        </motion.div>
                                    </Card.Body>
                                </Card>
                            </Col>
                        )}
                    </Row>

                    <Row>
                        <Col md={12} className='text-center mt-4'>
                            <Link to="/chefs" className="btn btn-danger">View More Chefs <i className="ri-arrow-right-fill ms-1"></i></Link>
                        </Col>
                    </Row>
                </Container>
            </motion.section>
        </>
    )
}
